import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const BrandPage = () => {
  const brands = [
    {
      name: "Earfit",
      description: "얼핏은 빠르게 변화하는 세상 속에서 '느리지만 확실한 아름다움'을 추구하는 슬로우에이징 스킨케어 브랜드입니다. 마이크로바이옴과 세라마이드 기반의 피부 장벽 케어로, 매일의 피부 루틴을 차분하게 지켜줍니다.",
      category: "스킨케어",
      marketEntry: "2024년 3월",
      image: "https://public.readdy.ai/ai/img_res/347e7a24412814b717f36b651caec9f8.jpg"
    },
    {
      name: "HAU",
      description: "자연주의 뷰티 브랜드",
      category: "내추럴 코스메틱",
      marketEntry: "2024년 5월",
      image: "https://readdy.ai/api/search-image?query=natural%20Korean%20beauty%20products%20with%20organic%20ingredients%2C%20eco-friendly%20packaging%20design%2C%20green%20and%20earth%20tone%20colors%2C%20sustainable%20cosmetic%20brand%20aesthetic%2C%20natural%20skincare%20products%20photography&width=600&height=400&seq=brand-hau-detail-002&orientation=landscape"
    },
    {
      name: "EJABON 이자본",
      description: "프리미엄 안티에이징 솔루션",
      category: "안티에이징",
      marketEntry: "2024년 7월",
      image: "https://readdy.ai/api/search-image?query=premium%20Korean%20anti-aging%20cosmetic%20products%2C%20sophisticated%20black%20and%20silver%20packaging%2C%20luxury%20skincare%20brand%20photography%2C%20high-end%20beauty%20products%20with%20elegant%20design%2C%20professional%20product%20shots&width=600&height=400&seq=brand-ejabon-detail-003&orientation=landscape"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-light text-black mb-6 leading-tight">
              Our Brands
            </h1>
            <p className="text-xl text-gray-600 font-light">
              LILYX GLOBAL과 함께 미국 시장에 진출한 K-뷰티 브랜드들
            </p>
          </div>
        </div>
      </section>

      {/* Brands Section */}
      <section className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="space-y-32">
              {brands.map((brand, index) => (
                <div key={index} className={`grid lg:grid-cols-2 gap-16 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                  <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                    <div className="bg-gray-100 aspect-[3/2] overflow-hidden">
                      <img 
                        src={brand.image}
                        alt={brand.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                  
                  <div className={index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}>
                    <div className="space-y-6">
                      <div className="flex items-center space-x-4 text-sm text-gray-600">
                        <span className="px-3 py-1 bg-gray-100 text-black font-medium">{brand.category}</span>
                        <span>미국 진출: {brand.marketEntry}</span>
                      </div>
                      
                      <h2 className="text-4xl font-light text-black">{brand.name}</h2>
                      
                      <p className="text-lg text-gray-600 font-light leading-relaxed">
                        {brand.description}
                      </p>
                      
                      <div className="space-y-4">
                        <div className="flex items-center space-x-4">
                          <div className="w-2 h-2 bg-black rounded-full"></div>
                          <span className="text-gray-800">eBay US 성공적인 런칭</span>
                        </div>
                        <div className="flex items-center space-x-4">
                          <div className="w-2 h-2 bg-black rounded-full"></div>
                          <span className="text-gray-800">지속적인 매출 성장</span>
                        </div>
                        <div className="flex items-center space-x-4">
                          <div className="w-2 h-2 bg-black rounded-full"></div>
                          <span className="text-gray-800">높은 고객 만족도</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-light text-black mb-8">
              다음은 당신의 브랜드입니다
            </h2>
            <p className="text-lg text-gray-600 mb-12 font-light">
              LILYX GLOBAL과 함께 미국 시장에 진출하세요
            </p>
            <a 
              href="/contact"
              className="inline-flex items-center bg-black text-white px-12 py-4 hover:bg-gray-800 transition-colors duration-300 text-lg font-medium whitespace-nowrap cursor-pointer group"
            >
              브랜드 제휴 문의
              <i className="ri-arrow-right-line ml-3 group-hover:translate-x-1 transition-transform duration-300"></i>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BrandPage;
